import React from 'react'

import {
  useAPIGetKompetensiKategoriOptions,
  useAPIGetKompetensiKegiatanOptions,
} from 'api/kinerja/pengawas-sekolah/perencanaan'

import type {
  TPengembanganKompetensiKategori,
  TPengembanganKompetensiKegiatan,
} from 'types/kinerja-ps-pegawai'

type TPengembanganKompetensiHooks = {
  kompetensiKategoriData: TPengembanganKompetensiKategori[]
  kompetensiKegiatanData: TPengembanganKompetensiKegiatan[]
}
export const usePengembanganKompetensi = (
  kategoriId?: string
): TPengembanganKompetensiHooks => {
  const {
    data: kompetensiKategoriResponse,
    isSuccess: isKompetensiKategoriSuccess,
  } = useAPIGetKompetensiKategoriOptions()

  const {
    data: kompetensiKegiatanResponse,
    isSuccess: isKompetensiKegiatanSuccess,
  } = useAPIGetKompetensiKegiatanOptions({
    kategoriId,
    enabled: Boolean(kategoriId),
  })

  const kompetensiKategoriData = React.useMemo(() => {
    if (isKompetensiKategoriSuccess) {
      return kompetensiKategoriResponse?.data ?? []
    }

    return []
  }, [isKompetensiKategoriSuccess, kompetensiKategoriResponse?.data])

  const kompetensiKegiatanData = React.useMemo(() => {
    if (isKompetensiKegiatanSuccess) {
      return kompetensiKegiatanResponse?.data ?? []
    }

    return []
  }, [isKompetensiKegiatanSuccess, kompetensiKegiatanResponse?.data])

  return {
    kompetensiKategoriData,
    kompetensiKegiatanData,
  }
}
